import React, { useState } from 'react';

import { getDefaultTrussDesignDrawingTemplateIds } from '@paragon/client-tools';
import { ChooseTrussDesignDrawingTemplates } from '@paragon/material';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { ChooseTrussDesignDrawingTemplateSubmitAction } from '../../store/actions/dialogActions';
import { continueAfterChooseTrussDesignDrawingTemplatesSubmission } from '../../store/actions/download';
import { ProjectActionScope } from '../../store/projectActionScope';
import { useAppDispatch, useAppSelector } from '../hooks';

const getSubmitText = (chooseTrussDesignDrawingTemplateSubmitAction: ChooseTrussDesignDrawingTemplateSubmitAction) => {
  switch (chooseTrussDesignDrawingTemplateSubmitAction) {
    case 'RequestSeals':
      return 'Request Seals';
    case 'RequestRepair':
      return 'Request Repair';
    default:
      assertExhaustiveSwitch(
        chooseTrussDesignDrawingTemplateSubmitAction,
        'Unrecognized ChooseTrussDesignDrawingTemplateSubmitAction.',
      );
  }
};

type OwnProps = {
  chooseTrussDesignDrawingTemplateSubmitAction: ChooseTrussDesignDrawingTemplateSubmitAction;
  scope: ProjectActionScope;
};

export default function ChooseTrussDesignDrawingTemplatesDialog({
  chooseTrussDesignDrawingTemplateSubmitAction,
  scope,
}: OwnProps) {
  const dispatch = useAppDispatch();
  const annotationTemplates = useAppSelector((state) => state.annotationTemplates);

  const isRepair = chooseTrussDesignDrawingTemplateSubmitAction === 'RequestRepair';
  const [defaultTemplateIds] = useState(() => getDefaultTrussDesignDrawingTemplateIds(annotationTemplates, isRepair));
  const [selectedTrussDesignDrawingTemplateId, setSelectedTrussDesignDrawingTemplateId] = useState<number | null>(
    defaultTemplateIds.templateId,
  );
  const [selectedTrussDesignDrawingOverflowTemplateId, setSelectedTrussDesignDrawingOverflowTemplateId] = useState<
    number | null
  >(defaultTemplateIds.overflowTemplateId);

  return (
    <Dialog
      title="Choose Templates"
      onCancel="close"
      submitText={getSubmitText(chooseTrussDesignDrawingTemplateSubmitAction)}
      onSubmit={() => {
        dispatch(
          continueAfterChooseTrussDesignDrawingTemplatesSubmission(
            chooseTrussDesignDrawingTemplateSubmitAction,
            scope,
            selectedTrussDesignDrawingTemplateId,
            selectedTrussDesignDrawingOverflowTemplateId,
          ),
        );
        dispatch(closeCurrentPopup());
      }}
    >
      <ChooseTrussDesignDrawingTemplates
        templates={annotationTemplates}
        selectedTrussDesignDrawingTemplateId={selectedTrussDesignDrawingTemplateId}
        setSelectedTrussDesignDrawingTemplateId={setSelectedTrussDesignDrawingTemplateId}
        selectedTrussDesignDrawingOverflowTemplateId={selectedTrussDesignDrawingOverflowTemplateId}
        setSelectedTrussDesignDrawingOverflowTemplateId={setSelectedTrussDesignDrawingOverflowTemplateId}
        type={isRepair ? 'repair' : 'standard'}
      />
    </Dialog>
  );
}
